// Copyright 2026. WebPros International GmbH. All rights reserved.

import mixpanel from 'mixpanel-browser';
import { MD5 } from 'crypto-js';

let isInitialized = false;
let clusterValue: string | null = null;

function createDistinctId(cluster: string, userId: number): string {
    const combinedString = `${cluster}_${userId}`;
    return MD5(combinedString).toString();
}

export function initMixpanel(cluster: string, userId?: number): void {
    if (!process.env.REACT_APP_MIXPANEL_TOKEN) {
        return;
    }

    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
        debug: false,
        api_host: process.env.REACT_APP_MIXPANEL_API_HOST as string,
        property_blacklist: ['$initial_referrer'],
    });

    clusterValue = cluster;
    isInitialized = true;

    if (userId !== undefined) {
        updateUserId(userId);
    }
}

export function updateUserId(userId: number): void {

    const newDistinctId = createDistinctId(clusterValue as string, userId);

    // Check if user is already identified with this ID
    if (mixpanel.get_distinct_id() === newDistinctId) {
        return;
    }

    mixpanel.identify(newDistinctId);

    mixpanel.people.set({
        'SVM:clusterId': clusterValue,
    });
}

export function track(eventName: string, properties: Record<string, unknown> = {}): void {
    try {
        if (!isInitialized) {
            return;
        }

        const eventProperties = {
            ...properties,
            cluster: clusterValue,
        };

        mixpanel.track(eventName, eventProperties);
    } catch {
        // TODO: add error reporting to sentry SVM2-6500
    }
}

export { mixpanel };
export default initMixpanel;